import request from "@/utils/request";

//竞赛报名
export const  signRace =(data) =>{
    return request({
        url: "/businessservice/raceSign/create",
        method:"post",
        data: data
    })
}

//竞赛报名用户列表
export const  pageRaceSign =(data) =>{
    return request({
        url: "/businessservice/raceSign/page",
        method:"post",
        data: data
    })
}

//活动报名用户列表
export const  pageActivitySign =(data) =>{
    return request({
        url: "/businessservice/raceSign/pageActivity",
        method:"post",
        data: data
    })
}

//查询竞赛报名信息详情
export const  infoRaceSign =(query) =>{
    return request({
        url: "/businessservice/raceSign/info",
        method:"get",
        params: query
    })
}

//删除竞赛报名信息详情
export const  deleteRaceSign =(query) =>{
    return request({
        url: "/businessservice/raceSign/delete",
        method:"get",
        params: query
    })
}

//查询竞赛报名信息详情
export const  infoActivitySign =(query) =>{
    return request({
        url: "/businessservice/raceSign/infoActivity",
        method:"get",
        params: query
    })
}

//查询竞赛报名信息详情
export const  infoRaceSignWeb =(data) =>{
    return request({
        url: "/businessservice/raceSign/infoWeb",
        method:"post",
        data: data
    })
}

export const  infoActivitySignWeb =(data) =>{
    return request({
        url: "/businessservice/raceSign/infoActivityWeb",
        method:"post",
        data: data
    })
}


//分配审核人
export const  divideCheckUser =(data) =>{
    return request({
        url: "/businessservice/raceSign/divideCheckUser",
        method:"post",
        data: data
    })
}

//查询审核列表
export const  listRaceSign =(query) =>{
    return request({
        url: "/businessservice/raceSign/list",
        method:"get",
        params: query
    })
}

export const  listActivitySign =(query) =>{
    return request({
        url: "/businessservice/raceSign/listActivity",
        method:"get",
        params: query
    })
}

//初审审核
export const  csRaceSignCheck =(data) =>{
    return request({
        url: "/businessservice/raceSign/csCheck",
        method:"post",
        data: data
    })
}

//竞赛复审审核
export const  fsRaceSignCheck =(data) =>{
    return request({
        url: "/businessservice/raceSign/fsCheck",
        method:"post",
        data: data
    })
}

//活动复审审核
export const  fsActivitySignCheck =(data) =>{
    return request({
        url: "/businessservice/raceSign/fsCheckActivity",
        method:"post",
        data: data
    })
}

//终审审核
export const  zsRaceSignCheck =(data) =>{
    return request({
        url: "/businessservice/raceSign/zsCheck",
        method:"post",
        data: data
    })
}
//活动终审审核
export const  zsActivitySignCheck =(data) =>{
    return request({
        url: "/businessservice/raceSign/zsCheckActivity",
        method:"post",
        data: data
    })
}


//录入现场分
export const  raceSignXcScore =(data) =>{
    return request({
        url: "/businessservice/raceSign/xcScore",
        method:"post",
        data: data
    })
}

//活动录入现场分
export const  activitySignXcScore =(data) =>{
    return request({
        url: "/businessservice/raceSign/xcScoreActivity",
        method:"post",
        data: data
    })
}

// 奖项定级
export const  raceSignAwardRate =(data) =>{
    return request({
        url: "/businessservice/raceSign/awardRate",
        method:"post",
        data: data
    })
}

// 奖项定级
export const activitySignAwardRate =(data) =>{
    return request({
        url: "/businessservice/raceSign/awardRateActivity",
        method:"post",
        data: data
    })
}